import apiClient, { API_ENDPOINTS, dispatchAndResolve, rejectWithError } from "api";
import * as types from "./types.jsx";

const { quote } = API_ENDPOINTS;

const rejectQuoteError = (error, label) => rejectWithError(error, label);

export const getQuoteById = (id) => async (dispatch) => {
    try {
        const data = await apiClient.get(quote.getById, { pathParams: { id } });
        return dispatchAndResolve(dispatch, types.GET_QUOTE, data);
    } catch (error) {
        return rejectQuoteError(error, "Error getting quote by id");
    }
};

export const updateQuote = (quotePayload) => async (dispatch) => {
    try {
        const data = await apiClient.post(quote.update, quotePayload);
        return dispatchAndResolve(dispatch, types.UPDATE_QUOTE, data);
    } catch (error) {
        return rejectQuoteError(error, "Error updating quote");
    }
};

export const updateQuoteWithType = (quotePayload, type = "") => async (dispatch) => {
    try {
        const data = await apiClient.post(quote.update, quotePayload, {
            query: { type }
        });
        return dispatchAndResolve(dispatch, types.UPDATE_QUOTE, data);
    } catch (error) {
        return rejectQuoteError(error, "Error updating quote with type");
    }
};
